module.exports = __webpack_public_path__ + "img/rever-isotype.aacac03f.svg";